import React, { forwardRef } from 'react';
import { SvgIcon, SvgIconProps } from '@mui/material';

/**
 * Flow brand exclusive icon
 */
export const BoltFilledIcon: React.FC<SvgIconProps> = forwardRef((props, ref) => {
  return (
    <SvgIcon viewBox="2 2 20 20" ref={ref} {...props}>
      <path d="M14.9098 2.66L13.0298 10.8H19.5298L10.3298 21.28H9.10977L10.9898 13.14H4.46977L13.6898 2.66H14.9098Z" />
    </SvgIcon>
  );
});
